import { render, staticRenderFns } from "./ko-detail.vue?vue&type=template&id=fefbe9bc&"
import script from "./ko-detail.vue?vue&type=script&lang=js&"
export * from "./ko-detail.vue?vue&type=script&lang=js&"
import style0 from "./ko-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports